import controller from './password-change.controller';
import template from './password-change.html';

export default {
	template,
	bindings: {
		confirmUid:   '<?',
		onCancel:     '&?',
		onSubmit:     '&',
		submitButton: '@',
		logoutButton: '<?',
	},
	controller,
	controllerAs: '$ctrl',
};
